import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { resetStates } from "../../../actions/Common";
import { ApplicationState } from "../../../redux/ApplicationState";
import DocumentUpload from "../components/DocumentUpload";

const mapStateToProps = ({
  tabSessionStorageState,
}: ApplicationState) => ({
  tabSessionStorage: tabSessionStorageState,
});
const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    any
  >
) => {
  return {
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentUpload);
